import React, { useRef } from "react";

// Components
import FormValidation from "pages/ticketing/components/FormValidation";
import LoadingSpinner from "components/LoadingSpinner";

const UploadUserFormModal = ({
  handleSubmitBtn,
  show,
  handleInputChange,
  userForm,
  loading,
}) => {
  const fileInput1Ref = useRef(null);
  const fileInput2Ref = useRef(null);

  const handleChangeDocument = (isGovernance, isProjectManagement) => {
    if (isGovernance) {
      if (fileInput1Ref.current) {
        fileInput1Ref.current.click();
      }
    }

    if (isProjectManagement) {
      if (fileInput2Ref.current) {
        fileInput2Ref.current.click();
      }
    }
  };

  if (!show) return null;

  return (
    <div className="text-justify">
      <h3 className="mb-6 text-xl font-semibold leading-snug">
        Ready to make your mark? <br />
        Submit your entry now!
      </h3>
      <p className="mb-3 text-sm leading-relaxed text-gray-700">
        Files must be submitted in Excel format. You can upload up to two files.
        Once submitted, participants will receive a confirmation email.
      </p>

      <div className="mb-2 text-sm text-gray-800 break-words">
        <p className="mb-1">Please rename your files as follows:</p>
        <ul className="space-y-1 list-disc list-inside">
          <li className="text-left">
            <b>[Your Company Name]</b>_ESG_Governance_Awards_RFI_Governance
          </li>
          <li className="text-left">
            <b>[Your Company Name]</b>
            _ESG_Governance_Awards_RFI_Project_Management
          </li>
        </ul>
      </div>

      <div className="mb-4">
        <div>
          <label className="block mb-1 text-sm font-semibold">
            Upload Form<span className="text-red-500">*</span>
          </label>

          <div className="relative flex items-center justify-center w-full border-2 border-gray-300 border-dashed rounded-lg h-24 cursor-pointer hover:border-[#E78D41] transition">
            <input
              ref={fileInput1Ref}
              type="file"
              name="userDocument1"
              className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
              accept=".xls,.xlsx"
              onChange={(e) =>
                handleInputChange(e.target.name, e.target.files, true)
              }
            />

            {userForm?.userDocument1 ? (
              <div
                className="flex flex-col items-center justify-center ml-5 mr-5 pointer-events-none"
                onClick={handleChangeDocument}
              >
                <div className="text-sm text-center break-all">
                  {userForm.userDocument1.name}
                </div>
                <span className="mt-2 text-sm text-gray-400">
                  Change Document
                </span>
              </div>
            ) : (
              <div className="text-center">
                <div className="text-gray-400 pointer-events-none">
                  Upload Here
                </div>
                <div className="mt-2 text-xs text-gray-400 break-words pointer-events-none">
                  Max file size 10 Mb & Only accept file Excel with formatted
                  File Name
                </div>
              </div>
            )}
          </div>
          <FormValidation
            value={userForm.userDocument1}
            showError={
              !userForm.validUserDocument1 ||
              !userForm.validUserDocument1FileSize ||
              !userForm.validUserDocument1FileType ||
              !userForm.validUserDocument1FileName
            }
            errorMsg={
              !userForm.validUserDocument1FileSize
                ? "File is too large! Max size is 10MB."
                : !userForm.validUserDocument1FileType
                ? "Only .xls or .xlsx Excel files are allowed."
                : !userForm.validUserDocument1FileName
                ? "File name must not contain hyphens (‘-’). Please rename and upload again."
                : ""
            }
          />
        </div>
      </div>

      {userForm?.userDocument1 ? (
        <div className="mb-4">
          <div>
            <label className="block mb-1 text-sm font-semibold">
              Upload Second Form
              <span className="text-red-500"></span>
            </label>

            <div className="relative flex items-center justify-center w-full border-2 border-gray-300 border-dashed rounded-lg h-24 cursor-pointer hover:border-[#E78D41] transition">
              <input
                ref={fileInput2Ref}
                type="file"
                name="userDocument2"
                className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
                accept=".xls,.xlsx"
                onChange={(e) =>
                  handleInputChange(e.target.name, e.target.files, true)
                }
              />

              {userForm?.userDocument2 ? (
                <div
                  className="flex flex-col items-center justify-center m-2 pointer-events-none"
                  onClick={handleChangeDocument}
                >
                  <div className="text-sm text-center break-all">
                    {userForm.userDocument2.name}
                  </div>
                  <span className="mt-2 text-sm text-gray-400">
                    Change Document
                  </span>
                </div>
              ) : (
                <div className="text-center">
                  <div className="text-gray-400 pointer-events-none">
                    Upload Here
                  </div>
                  <div className="mt-2 text-xs text-gray-400 break-words pointer-events-none">
                    Max file size 10 Mb & Only accept file Excel with formatted
                    File Name
                  </div>
                </div>
              )}
            </div>

            <FormValidation
              value={userForm.userDocument2}
              showError={
                !userForm.validUserDocument2 ||
                !userForm.validUserDocument2FileSize ||
                !userForm.validUserDocument2FileType ||
                !userForm.validUserDocument2FileName
              }
              errorMsg={
                !userForm.validUserDocument2FileSize
                  ? "File is too large! Max size is 10MB."
                  : !userForm.validUserDocument2FileType
                  ? "Only .xls or .xlsx Excel files are allowed."
                  : !userForm.validUserDocument2FileName
                  ? "File name must not contain hyphens (‘-’). Please rename and upload again."
                  : ""
              }
            />
          </div>
        </div>
      ) : null}

      <div className="mb-4">
        <div>
          <label className="block mb-1 text-sm font-semibold">
            Upload Evidence
          </label>

          <div className="relative flex items-center justify-center w-full border-2 border-gray-300 border-dashed rounded-lg h-24 cursor-pointer hover:border-[#E78D41] transition">
            <input
              ref={fileInput1Ref}
              type="file"
              name="userDocumentEvidence"
              className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
              accept=".xls,.xlsx,.pdf,.doc,.docx"
              onChange={(e) =>
                handleInputChange(e.target.name, e.target.files, true)
              }
            />

            {userForm?.userDocumentEvidence ? (
              <div
                className="flex flex-col items-center justify-center ml-5 mr-5 pointer-events-none"
                onClick={handleChangeDocument}
              >
                <div className="text-sm text-center break-all">
                  {userForm.userDocumentEvidence.name}
                </div>
                <span className="mt-2 text-sm text-gray-400">
                  Change Document
                </span>
              </div>
            ) : (
              <div className="text-center">
                <div className="text-gray-400 pointer-events-none">
                  Upload Here
                </div>
                <div className="mt-2 text-xs text-gray-400 break-words pointer-events-none">
                  Max file size 10 Mb & Only accept file Excel / PDF / Word
                </div>
              </div>
            )}
          </div>
          <FormValidation
            value={userForm.userDocumentEvidence}
            showError={
              !userForm.validUserDocumentEvidence ||
              !userForm.validUserDocumentEvidenceFileSize ||
              !userForm.validUserDocumentEvidenceFileType ||
              !userForm.validUserDocumentEvidenceFileName
            }
            errorMsg={
              !userForm.validUserDocumentEvidenceFileSize
                ? "File is too large! Max size is 10MB."
                : !userForm.validUserDocumentEvidenceFileType
                ? "Only .xls / .xlsx / .pdf / .doc / .docx files are allowed."
                : !userForm.validUserDocumentEvidenceFileName
                ? "File name must not contain hyphens (‘-’). Please rename and upload again."
                : ""
            }
          />
        </div>
      </div>

      <div className="flex justify-end pt-2">
        <div
          className="px-5 py-2 rounded-md bg-[#F58220] text-white hover:bg-[#D67E32] transition text-sm font-medium cursor-pointer"
          onClick={() => handleSubmitBtn()}
        >
          {loading ? <LoadingSpinner isLoading={loading} /> : "Submit Form"}
        </div>
      </div>
    </div>
  );
};

export default UploadUserFormModal;
